import { render } from "./ModifyFriezeComponent.vue?vue&type=template&id=6600f408&scoped=true"
import script from "./ModifyFriezeComponent.vue?vue&type=script&lang=js"
export * from "./ModifyFriezeComponent.vue?vue&type=script&lang=js"

import "./ModifyFriezeComponent.vue?vue&type=style&index=0&id=6600f408&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6600f408"]])

export default __exports__